export default {
    methods: {
        setBadgeClass (signature) {
            let classList = this.customClass;
            switch (signature?.signatory_group.toLowerCase()) {
                case "tenant":
                    classList += " text-green-600 bg-green-100 hover:text-green-800 hover:bg-green-200";
                    break;
                case "landlord":
                    classList += " text-orange-600 bg-orange-100 hover:text-orange-800 hover:bg-orange-200";
                    break;
                case "inspector":
                case "agent":
                    classList += " text-indigo-600 bg-indigo-100 hover:text-indigo-800 hover:bg-indigo-200";
                    break;
                case "other":
                    classList += " text-yellow-600 bg-yellow-100 hover:text-yellow-800 hover:bg-yellow-200";
                    break;
                default:
                    classList += " text-gray-600 bg-gray-200 cursor-default";
            }

            return classList + ' transition duration-300';
        },

        setTitle (signature) {
            switch (signature?.signatory_group.toLowerCase()) {
                case "tenant":
                    return "Tenant Signature";
                case "landlord":
                    return "Landlord Signature";
                case "inspector":
                case "agent":
                    return "Inspector Signature";
                case "other":
                    return "Other Signature";
                default:
                    return "No Signatures";
            }
        },

        deleteSignature (signatureId, inspection) {
            if (inspection?.signatures?.length > 0) {
                let index = inspection.signatures.findIndex(signature => signature.id === signatureId);
                if (index !== -1) {
                    inspection.signatures.splice(index, 1);
                }
            }
        },
    },
};
